<template>
    <div class="container">
        <triangle-image
            :title="$t('components.cookbook.title')"
            :subtitle="$t('components.cookbook.subtitle')"
        />

        <div class="content">
            <div class="overlay-block" v-if="loading"></div>
                <div class="search-group">
                    <i class="fas fa-search" />
                    <input class="search" placeholder="Cerca per ricetta o ingrediente" v-model="searchDetails">
                </div>
                <div id="scrollHere"></div>

                <template v-if="$mq.isDesktop()">
                    <div class="inline">
                        <div class="flex wrap cat_listing">
                            <div v-for="(filter, key) in filters" class="cat_container" :key="key">
                                <div class="flex cat_head" @click="openedBox = openedBox === key ? null : key">
                                    <div>{{ filter.head }}</div>
                                    <div class="flex-right">
                                        <i class="fa fa-angle-down" :class="{ 'rotated': openedBox === key }" aria-hidden="true" />
                                    </div>
                                </div>
                                <transition name="modal-on">
                                    <div class="cat_box" v-if="openedBox === key">
                                        <div
                                            class="cat_item"
                                            v-for="(item, key) in filter.list"
                                            :key="key"
                                            @click="selectFilter(filter, item)"
                                            :class="{ 'selected': filter.selectedId === item.id }"
                                        >
                                            {{ item.name }}
                                        </div>
                                    </div>
                                </transition>
                            </div>
                        </div>
                    </div>
                </template>

                <template v-if="!$mq.isDesktop()">
                    <div class="filters flex-vcenter" @click="openFilters()">
                        Filtri <i class="fas fa-sliders-h flex-right"></i>
                    </div>
                    <transition name="slide-fade">
                        <div v-if="openedFilters" class="overlay" :style="[$_appViewPosition_positionTop, $_appViewPosition_positionBottom]">

                            <div
                                class="filters-header flex-vcenter"
                                @click="closeFilters()"
                                :style="[$_appViewPosition_positionTop]"
                            >
                                <h4><i class="fas fa-angle-left"></i> Ricette</h4>
                            </div>

                            <div class="filters-viewpoint">
                                <div v-for="(filter, key) in filters" class="cat_container" :key="key">
                                    <div class="flex cat_head">
                                        <div>{{ filter.head }}</div>
                                    </div>
                                    <div class="cat_item_list">
                                        <div
                                            class="cat_item inline"
                                            v-for="(item, key) in filter.list"
                                            :key="key"
                                            @click="preselectFilter(filter, item)"
                                            :class="{ 'selected': filter.preselectedId === item.id }"
                                        >
                                            {{ item.name }}
                                        </div>
                                    </div>
                                </div>

                                 <div v-if="countRecipes !== null" class="cat_container">
                                    Risultati: {{ countRecipes }}
                                </div>
                            </div>

                            <div class="filters-footer flex-center" :style="[$_appViewPosition_positionBottom]">
                                <CTA
                                    @click="applyFilters()"
                                    :content="`Applica`"
                                />
                            </div>

                        </div>
                    </transition>
                </template>

                <template>
                    <div class="filter-box inline" v-if="$mq.isDesktop()">
                        <div class='filter-label inline'>Filtri selezionati: <span v-if="!selectedFilters.find(r => r.src !== null)">Nessuno</span></div> 

                        <div v-if="selectedFilters[0].src" class="filter-selected inline" @click="filters.cg1.selectedId = null">
                            {{ selectedFilters[0].src }} x
                        </div>
                        <div v-if="selectedFilters[1].src" class="filter-selected inline" @click="filters.cg2.selectedId = null">
                            {{ selectedFilters[1].src }} x
                        </div>
                        <div v-if="selectedFilters[2].src" class="filter-selected inline" @click="filters.time.selectedId = null">
                            {{ selectedFilters[2].src }} x
                        </div>
                    </div>
                </template>

                <div class="recipes_inner">
                    <div class="recipes-listing" v-if="recipes">
                        <div class="no-result" v-if="recipes.length === 0">
                            <p>Nessuna ricetta trovata, modifica i filtri selezionati</p>
                        </div>
                        <recipe-box
                            v-for="(recipe, index) in recipes"
                            :item="recipe"
                            isBoxWithLink
                            isHover
                            :key="index"
                            :path="'cookbook-recipe'"
                        />
                    </div>
                    <loading-spin
                        :height='200'
                        v-if="!recipes"
                    />
                </div>

                <pagination
                    v-if="pagination"
                    :currentPage="pagination.page"
                    :lastPage="pagination.pages"
                    @selectPage='page = $event'
                />
        </div>

        <start-with-us />
    </div>
</template>

<script>
import RecipeBox from './RecipeBox'
import TriangleImage from './TriangleImage'
import Pagination from './Parts/Pagination'
import StartWithUs from './Parts/StartWithUs'

import { scrollToElementId, debounce } from '../assets/js/main'

import { AllRecipesApi } from '../api/AllRecipesApi'

export default {
    data () {
        return {
            filters: {
                cg2: {
                    head: 'Tipologia',
                    list: [
                        {
                            id: 1,
                            name: 'Vegetariana',
                            src: ['Vegetariano']
                        },
                        {
                            id: 2,
                            name: 'Vegana',
                            src: ['Vegano']
                        },
                        {
                            id: 3,
                            name: 'Carne rossa',
                            src: ['Carne rossa', 'Bovino', 'Ovino', 'Maiale']
                        },
                        {
                            id: 4,
                            name: 'Carne bianca',
                            src: ['Carne bianca', 'Pollo / Tacchino', 'Salumi']
                        },
                        {
                            id: 5,
                            name: 'Pesce',
                            src: ['Pesce']
                        }
                    ],
                    preselectedId: null,
                    selectedId: null
                },
                cg1: {
                    head: 'Piatto',
                    list: [
                        {
                            id: 1,
                            name: 'Pasta secca',
                            src: ['Pasta secca']
                        },
                        {
                            id: 2,
                            name: 'Pasta fresca',
                            src: ['Pasta fresca']
                        },
                        {
                            id: 3,
                            name: 'Pasta',
                            src: ['Pasta']
                        },
                        {
                            id: 4,
                            name: 'Cereale',
                            src: ['Cereale']
                        },
                        {
                            id: 5,
                            name: 'Riso',
                            src: ['Riso']
                        },
                        {
                            id: 6,
                            name: 'Legumotti',
                            src: ['Legumotti']
                        },
                        {
                            id: 7,
                            name: 'Secondo',
                            src: ['Secondo']
                        },
                        {
                            id: 8,
                            name: 'Zuppa',
                            src: ['Zuppa']
                        },
                        {
                            id: 9,
                            name: 'Orzo',
                            src: ['Orzo']
                        },
                        {
                            id: 10,
                            name: 'Dolce',
                            src: ['Dessert']
                        }
                    ],
                    preselectedId: null,
                    selectedId: null
                },
                time: {
                    head: 'Tempo',
                    list: [
                        {
                            id: 1,
                            name: 'Fino 20\'',
                            src: [0, 20]
                        },
                        {
                            id: 2,
                            name: 'Da 20\' a 30\'',
                            src: [20, 30]
                        },
                        {
                            id: 3,
                            name: 'Da 30\' a 40\'',
                            src: [30, 40]
                        },
                        {
                            id: 4,
                            name: 'Più di 40\'',
                            src: [40, 99999]
                        }
                    ],
                    preselectedId: null,
                    selectedId: null
                },
            },

            recipes: null,

            searchDetails: null,

            loading: false,

            page: null,
            pagination: null,

            recipeLoading: false,
            loadingId: null,

            show: 12,

            countRecipes: null,

            openedBox: null,
            openedFilters: false
        }
    },

    components: {
        'recipe-box': RecipeBox,
        'start-with-us': StartWithUs,
        'triangle-image': TriangleImage,
        'pagination': Pagination
    },

    computed: {
        selectedFilters () {
            return [
                { src: this.filters.cg1.selectedId && this.filters.cg1.list.find(r => r.id === this.filters.cg1.selectedId).name },
                { src: this.filters.cg2.selectedId && this.filters.cg2.list.find(r => r.id === this.filters.cg2.selectedId).name },
                { src: this.filters.time.selectedId && this.filters.time.list.find(r => r.id === this.filters.time.selectedId).name }
            ]
        }
    },

    watch: {
        '$route' (from, to) {
            this.setParams()
        },

        'page' () {
            this.pushRouter()
            scrollToElementId('scrollHere', 1) 
        },

        'searchDetails' () {
            this.debouncedPushing()
        },

        'filters.cg1.selectedId' () {
            this.pushRouter()
        },

        'filters.cg2.selectedId' () {
            this.pushRouter()
        },

        'filters.time.selectedId' () {
            this.pushRouter()
        },

        'filters.cg1.preselectedId' () {
            this.debouncedPreloading()
        },

        'filters.cg2.preselectedId' () {
            this.debouncedPreloading()
        },

        'filters.time.preselectedId' () {
            this.debouncedPreloading()
        }
    },

    methods: {
        loadApi () {
            this.recipesApi = new AllRecipesApi()
        },

        load () {
             this.debouncedPushing = debounce(function() {
                this.pushRouter()
            }, 800)

            this.debouncedPreloading = debounce(function() {
                this.preloadRecipes()
            }, 500)

            scrollToElementId()
            this.setParams()
        },

        setParams () {
            this.page = this.$route.query.page ? this.$route.query.page : 1
            this.searchDetails = this.$route.query.searchDetails ? this.$route.query.searchDetails : null
    
            for (let key in this.filters) {
                this.filters[key].selectedId = this.$route.query[key]
                    ? this.filters[key].list.find(r => r.name === this.$route.query[key]).id
                    : null
                this.filters[key].preselectedId = this.filters[key].selectedId
            }

            this.loadRecipes({page: this.page})
        },

        query (vars) {
            var q = []

            if (vars.search) {
                var words = vars.search.split(' ').filter(v => v !== '')
                q['recipe'] = '(' + words.map(w => 'recipes.name ct "' + w + '"').join(' and ') + ')'
            }

            if (vars.cg1Id) {
                var words = this.filters.cg1.list.find(r => r.id === vars.cg1Id).src
                q['cg1'] = '(' + words.map(w => 'product.cg1 eq "' + w + '"').join(' or ') + ')'
            }

            if (vars.cg2Id) {
                var words = this.filters.cg2.list.find(r => r.id === vars.cg2Id).src
                q['cg2'] = '(' + words.map(w => 'product.cg2 eq "' + w + '"').join(' or ') + ')'
            }

            if (vars.timeId) {
                var from = this.filters.time.list.find(r => r.id === vars.timeId).src[0]
                var to = this.filters.time.list.find(r => r.id === vars.timeId).src[1]
                q['time'] = '(recipes.preparation_time > ' + from + ' and recipes.preparation_time <= ' + to + ')'
            }

            return q
        },

        openFilters () {
            this.openedFilters = true
        },

        closeFilters () {
            this.openedFilters = false

            // remove preselection
            for (let key in this.filters) {
                this.filters[key].preselectedId = this.filters[key].selectedId
            }
        },

        applyFilters () {
            for (let key in this.filters) {
                this.filters[key].selectedId = this.filters[key].preselectedId
            }
            this.openedFilters = false
        },

        selectFilter (filter, item) {
            filter.selectedId = item.id
        },

        preselectFilter (filter, item) {
            // unselect by click on selected
            if (filter.preselectedId === item.id) {
                filter.preselectedId = null
                return
            }
            filter.preselectedId = item.id
        },

        pushRouter () {
            var query = {}

            query.page = this.page
            if (this.searchDetails) query.searchDetails = this.searchDetails
            if (this.selectedFilters[0].src) query.cg1 = this.selectedFilters[0].src
            if (this.selectedFilters[1].src) query.cg2 = this.selectedFilters[1].src
            if (this.selectedFilters[2].src) query.time = this.selectedFilters[2].src

            this.$router.push({
                name: this.$route.name,
                query: query
            })
        },

        loadRecipes (vars) { 
            if (this.loading) return Promise.resolve()
            this.loading = true

            return this.recipesApi.get({
                params: {
                    show: this.show,
                    page: vars.page,
                    sort_direction: 'desc',
                    query: Object.values(this.query({
                        search: this.searchDetails,
                        cg1Id: this.filters.cg1.selectedId,
                        cg2Id: this.filters.cg2.selectedId,
                        timeId: this.filters.time.selectedId
                    })).join(' and ')
                }
            }).then(response => {
                this.recipes = response.body.data.resources
                this.countRecipes = response.body.data.pagination.total

                this.pagination = response.body.data.pagination
                if (this.pagination.pages === 0) this.pagination.pages = 1
                this.page = this.pagination && this.page > this.pagination.pages ? this.pagination.pages : vars.page
                
                this.loading = false
                this.openedBox = null
            }).catch(response => {
                this.loading = false
            })
        },

        preloadRecipes () {
            return this.recipesApi.get({
                params: {
                    show: 1,
                    page: 1,
                    sort_direction: 'desc',
                    query: Object.values(this.query({
                        search: null,
                        cg1Id: this.filters.cg1.preselectedId,
                        cg2Id: this.filters.cg2.preselectedId,
                        timeId: this.filters.time.preselectedId
                    })).join(' and ')
                }
            }).then(response => {
                this.countRecipes = response.body.data.pagination.total
            }).catch(response => {
            })
        }
    },

    mounted () {
        this.loadApi()
        this.load()
    }
}

</script>

<style scoped>
.overlay {
    position: fixed;
    top: 0px;
    left: 0;
    background-color: white;
    width: 100%;
    height: 100vh;
    z-index: 5;
    overflow-y: auto;
}

.filters-header {
    position: fixed;
    top: 0;
    width: 100%;
    background-color: white;
    border-bottom: 1px solid #ededed;
    padding: 21px 8px 13px 8px;
}

h3 {
    margin-bottom: 0;
}

h4 {
    font-size: 18px;
    text-align: left;
}

.filters-viewpoint {
    padding: 50px 0;
}

.filters-viewpoint .cat_container,
.filters-viewpoint .cat_container + .cat_container {
    margin: 20px;
    overflow-y: hidden;
}

.filters-viewpoint .cat_item {
    margin: 10px;
    border: 1.5px solid #ededed;
    padding: 10px;
    white-space: nowrap;
    border-radius: 4px;
}

.filters-viewpoint .cat_item_list {
    margin-left: -40px;
    padding: 0 30px;
    display: flex;
    overflow-x: scroll;
}

.filters-viewpoint .cat_item_list::-webkit-scrollbar {
    display: none;
}

.filters-viewpoint .cat_item_list {
    -ms-overflow-style: none;
    margin-bottom: -42px;
    padding-bottom: 42px;
}

.filters-viewpoint .cat_item.selected {
    border: 1.5px solid var(--quomi-primary);
}

.filters-footer {
    position: fixed;
    bottom: 0;
    border-top: 1px solid #ededed;
    width: 100%;
    padding: 10px;
    background: white;
}

.filters-footer .btn {
    background-color: var(--quomi-primary);
    width: 100%;
}

.cat_container {
    margin: 30px 10px 20px 10px;
    font-size: 16px;
}

.cat_container + .cat_container {
    margin-left: 40px;
}

.cat_head {
    cursor: pointer;
}

.cat_head .flex-right {
    margin-left: 10px;
    width: 20px;
}

.fa {
    transition: all .1s ease;
    padding: 0 7px;
}
.fa.rotated {
    -webkit-transform: rotate(-90deg);
    -moz-transform: rotate(-90deg);
    -ms-transform: rotate(-90deg);
    -o-transform: rotate(-90deg);
}

.cat_box {
    border: 2px solid var(--quomi-primary);
    padding: 10px 10px 10px 25px;
    position: absolute;
    z-index: 2;
    background-color: white;
    width: 180px;
}

.cat_item {
    cursor: pointer;
    padding: 5px 0;
}

.cat_item.selected {
    font-weight: 500;
}

.filters {
    border: 2px solid #ededed;
    border-radius: 4px;
    font-size: 18px;
    padding: 10px;
    margin: 20px 0;
}

.filter-box {
    font-size: 18px;
    margin: 0 -5px 10px -5px;
}

.filter-box.inline {
    margin-left: 30px;
}
.filter-selected {
    background-color: #ededed;
    padding: 0px 10px;
    cursor: pointer;
    margin: 5px;
    border-radius: 4px;
}

.filter-label {
    margin: 5px;
}

.recipes_inner {
    min-height: 150px;
    position: relative;
}

.container {
    padding: 0;
}

.content {
    position: relative;
    padding:  40px 10px;
    max-width: 1200px;
}

.triangle-image {
    background-image: url("../assets/img/covers/cookbook.jpg");
}

input.search {
    width: 100%;
    margin: 0 auto;
    display: block;
    border-bottom: 2px solid var(--quomi-primary);
    font-size: 20px;
    padding-left: 25px;
}

input.search:focus {
    border-bottom: 2px solid var(--quomi-primary-hover);
}

.search-group {
    width: 100%;
    position: relative;
}

.fa-search {
    position: absolute;
    font-size: 18px;
    top: 5px;
    color: grey;
}

.recipes-listing {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin: 0 -10px;
    align-items: flex-start;
}

.overlay-block {
    opacity: 0.5;
    background: white;
    position: absolute;
    top: 0;
    width: 100%;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 3;
}

.recipe-box {
    flex-basis: calc(100% / 3 - 20px);
    max-width: calc(100% / 3 - 20px);
    margin: 10px;
    position: relative;
}

.no-result {
    margin: 10px;
    font-size: 18px;
}

@media (max-width: 1024px) {
    .recipe-box {
        flex-basis: calc(100% / 2 - 20px);
        max-width: calc(100% / 2 - 20px);
    }

    .filters-viewpoint {
        padding: 10% 0 ;
    }

    .cat_item_list {
        display: flex;
        flex-wrap: wrap;
    }

    .cat_head {
        font-weight: bold;
    }
}

@media (max-width: 600px) {
    .recipe-box {
        flex-basis: calc(100% / 1 - 20px);
        max-width: calc(100% / 1 - 20px);
    }

    .filters-viewpoint {
        padding: 20% 0;
    }
}
</style>
